<script lang="ts" setup>
interface LinkElementProps {
  text?: string
  to?: object | string
  href?: string
}

const { href, text, to } = defineProps<LinkElementProps>()
const router = useRouter()

const onClick = () => {
  if (to) {
    router.push(to)
  }
}
</script>

<template>
  <NuxtLink v-if="to" tag="a" :to="to" class="btn-link">
    <slot>{{ text }}</slot>
    <i class="fas fa-chevron-right fill-current pl-3" />
  </NuxtLink>
  <a v-else class="btn-link" :href="href" @click="onClick">
    <slot>{{ text }}</slot>
    <i class="fas fa-chevron-right fill-current pl-3" />
  </a>
</template>
